var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplestoredarkicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5921 16.2513C14.9004 17.2846 14.1671 18.293 13.0504 18.3096C11.9337 18.3346 11.5754 17.6513 10.3087 17.6513C9.03372 17.6513 8.64205 18.293 7.58369 18.3346C6.49203 18.3763 5.66703 17.2346 4.96703 16.2263C3.54203 14.168 2.45036 10.3763 3.91703 7.8263C4.64203 6.55964 5.94203 5.75964 7.35036 5.73464C8.41705 5.71797 9.43372 6.45964 10.0921 6.45964C10.7421 6.45964 11.9754 5.56797 13.2671 5.7013C13.8087 5.7263 15.3254 5.91797 16.3004 7.3513C16.2254 7.4013 14.4921 8.41797 14.5087 10.5263C14.5337 13.043 16.7171 13.8846 16.7421 13.893C16.7171 13.9513 16.3921 15.093 15.5921 16.2513ZM10.8337 2.91797C11.4421 2.2263 12.4504 1.7013 13.2837 1.66797C13.3921 2.64297 13.0004 3.6263 12.4171 4.3263C11.8421 5.03464 10.8921 5.58464 9.95872 5.50964C9.83372 4.5513 10.3004 3.5513 10.8337 2.91797Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplestoredarkicon);
export default __webpack_public_path__ + "static/media/apple store dark icon.6d327cd27ad8e4fe284909c6b88426fe.svg";
export { ForwardRef as ReactComponent };